export default {
  label: {
    fontSize: 20,
  },
};
